import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MmDuallistComponent } from './mm-duallist.component';

@NgModule({
  declarations: [MmDuallistComponent],
  imports: [
    CommonModule
  ],
  exports: [MmDuallistComponent]
})
export class MmDuallistModule { }
